import React from 'react';
import LearningStyleCard from './learningStyleChart'
import styled from 'styled-components';
import { StudentAd2Card } from "./ad2Card";
import { useTranslation } from "react-i18next";
import { NotCompleteText } from './commonStyles';
// Container Styles
const SectionContainer = styled.div`
  padding: 20px;
`;

const SectionTitle = styled.h2`
  font-size: 1.5rem;
  margin-bottom: 20px;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;


const LearningStyleSection = ({ data }) => {
    const { t } = useTranslation();
    
    // const Openness = data['Openness to Experience']?.points;
    // const Agreeableness = data['Agreeableness']?.points;
    // const Extraversion = data['Extraversion']?.points;
    // const Conscientiousness = data['Conscientiousness']?.points;
    const stylesData = Array.isArray(data) ? data : [];
    const VisualsKinesthetic = stylesData?.find(item => item.style === "Visual and Kinesthetic")?.score || 0
    const Aural = stylesData?.find(item => item.style === "Aural")?.score || 0
    const ReadWrite = stylesData?.find(item => item.style === "Read/Write")?.score || 0

    // function normalizeBetween0To5(val) {
    //     var newMin = 0;
    //     var newMax = 5;
    //     var oldMin = 0;
    //     var oldMax = 120;
    //     var newVal = newMin + (((val - oldMin) * (newMax - newMin)) / (oldMax - oldMin))
    //     return Math.round(newVal * 100) / 100;
    // };

    const LearningStyleContent = [
        {
            key: "Visual & Kinesthetic",
            points: [
                'Engaging with interactive simulations and physical models.',
                'Using diagrams, flowcharts, and illustrative videos to understand complex concepts.',
                'Participating in workshops where they can physically manipulate relevant materials.',
            ],
            description: 'Learners with a preference for the combined Visual and Kinesthetic style grasp concepts more effectively through direct interaction with learning materials. They thrive on engaging physically with tasks and benefit from the use of visual aids.',
            score: VisualsKinesthetic
        },
        {
            key: "Aural",
            points: [
                'Benefiting from lectures, group discussions, and verbal briefings.',
                'Using podcasts and audio recordings for learning new content.',
                'Participating in study groups or team meetings where ideas are discussed aloud.',
            ],
            description: 'Aural learners absorb information best when it is presented verbally. They excel in environments where listening and discussion are encouraged and are adept at remembering spoken instructions.',
            score: Aural
        }
        ,
        {
            key: "Read/Write",
            points: [
                'Using textbooks, articles, and written handouts as primary study materials.',
                'Making comprehensive lists, writing out notes, and summarizing information.',
                'Preferring email and text-based communication for clarity and record-keeping.',
            ],
            description: 'Read / Write learners prefer to interact with information through written words. They excel in traditional study methods involving reading and taking detailed notes',
            score: ReadWrite
        }
    ];
    
    return (
        <StudentAd2Card title={t("Learning Style")} sm="12" lg="12">
            <SectionContainer>
                <CardsContainer>
                {data?.status === "noDataFound"? (
                        <NotCompleteText style={{textAlign: "center", width: "100%"}}>{t("Not Completed")}</NotCompleteText>
                    ): (
                        LearningStyleContent.map((itm) =>(
                            <LearningStyleCard
                            title={itm.key}
                            percentage={Math.round(itm.score / 5 * 100)}
                            description={itm.description}
                            examples={itm.points}
                            />
                    ))
                    )}
                </CardsContainer>
            </SectionContainer>
        </StudentAd2Card>
    );
};

export default LearningStyleSection;

